<template lang="pug">
.update-scheduled-time-modal
  b-modal(ref="modal" size="md" no-close-on-backdrop no-close-on-esc @ok="submit")
    div(slot="modal-title")
      span 送信日時の変更

    .update-scheduled-time-modal-body
      .register-body.d-flex.flex-column
        FormDatetimePicker(v-model="scheduledTime" :date.sync="scheduledTimeDate" :time.sync="scheduledTimeTime"
          key-name="送信日時" name="scheduled-time" placeholder="送信日時"
          :validation-rules="{ required: true }" required)

    .update-scheduled-time-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }")
      .d-flex.flex-column.flex-fill
        .buttons
          ValidationAlert(v-model="showValidationAlert")
          .m-0
            button.btn.modal-ok-btn(type="button" @click="ok()") OK
            button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import FormDatetimePicker from "@/pc/components/forms/FormDatetimePicker.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";

@Component({
  components: {
    FormDatetimePicker,
    ValidationAlert
  },
  $_veeValidate: { validator: "new" }
})
export default class UpdateScheduledTimeModal extends Vue {
  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 送信日時 */
  scheduledTime: number | null = null;
  /** 送信日時(日) */
  scheduledTimeDate: string = "";
  /** 送信日時(時) */
  scheduledTimeTime: string = "";

  public show(currentTime: number): void {
    this.scheduledTime = currentTime;
    this.scheduledTimeDate = this.$dateUtil.convertNumberToString(currentTime, "yyyy-mm-dd");
    this.scheduledTimeTime = this.$dateUtil.convertNumberToString(currentTime, "hh:MM:ss");

    this.showValidationAlert = false;
    this.$validator.errors.clear();

    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }
  }

  public hide(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.hide();
    }
  }

  public setError(msg: string): void {
    this.$validator.errors.remove("scheduled-time");
    this.$validator.errors.add({ field: "scheduled-time", msg: msg });
    this.showValidationAlert = true;
  }

  public async submit(modalEvent: any): Promise<void> {
    modalEvent.preventDefault();

    const validationResult: boolean = await this.$validator.validateAll();
    const scheduledTimeValidationResult: boolean = this.scheduledTimeValidate(this.scheduledTime);

    if (validationResult === false || scheduledTimeValidationResult === false) {
      this.showValidationAlert = true;
    } else {
      this.showValidationAlert = false;
      this.$emit("submit", this.scheduledTime);
    }
  }

  private scheduledTimeValidate(scheduledTime: number | null): boolean {
    this.$validator.errors.remove("scheduled-time");

    if (scheduledTime == null) {
      return true;
    } else {
      // 現在日時より10分後でなければエラー
      const currentTime: Date = new Date();
      const scheduledTimeDate: Date = this.$dateUtil.convertNumberToDate(scheduledTime);
      const limitTime: Date = new Date(currentTime.getTime() + 10 * 60 * 1000);
      if (scheduledTimeDate < limitTime) {
        this.$validator.errors.add({ field: "scheduled-time", msg: "送信日時は現在日時より10分以上後の日時を設定してください" });
        return false;
      } else {
        return true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.update-scheduled-time-modal-body {
  padding: 10px;
}
.register-body {
  ::v-deep .register-group {
    margin: 0 !important;
  }
}
</style>
